import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import TableContainer from 'Common/TableContainer';
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from 'react-select';

// Icons
import { Search, Eye, Trash2, Plus, MoreHorizontal, FileEdit, CheckCircle, Loader, X, Download, SlidersHorizontal, ImagePlus , EyeOff } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

// Images
import dummyImg from "assets/images/users/user-dummy-img.jpg";

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { getView, getManager } from 'slices/thunk';
import { createManager } from "slices/settings/thunk";
import { RootState } from 'slices';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';


const ManagerCreations = () => {
    
    // password Visiblilty
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };
    // fetching from api
    const dispatch = useDispatch<any>();
    const manager = useSelector((state: RootState) => state.Ecommerce.Manager) as any[]



    useEffect(() => {
        dispatch(getManager('') as any)
    }, [dispatch])


    console.log(manager);


    const selectDataList = createSelector(
        (state: any) => state.Users,
        (user) => ({
            userList: user.userList
        })
    );

    const { userList } = useSelector(selectDataList);
    const [user, setUser] = useState<any>([]);
    const [eventData, setEventData] = useState<any>();

    const [show, setShow] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    useEffect(() => {
        setUser(userList);
    }, [userList]);





    // validation
    const validation: any = useFormik({
        enableReinitialize: true,

        initialValues: {
            username: (eventData && eventData.username) || '',
            mobile: (eventData && eventData.mobile) || '',
            countryCode: (eventData && eventData.countryCode) || '+971',
            country: (eventData && eventData.country) || '',
            email: (eventData && eventData.email) || '',
            password: (eventData && eventData.password) || '',



        },
        validationSchema: Yup.object({
            username: Yup.string().required("Please Enter Manager Name"),
            mobile: Yup.string()
                .required("Please Enter Mobile")
                .min(8, "Mobile number must be at least 8 digits")
                .max(12, "Mobile number must be at most 12 digits")
                .matches(/^\d+$/, "Mobile number must be digits only"),
            country: Yup.string().required("Please Enter Country"),
            email: Yup.string().required("Please Enter Email"),
            password: Yup.string().required("Please Enter Password"),
        }),


        onSubmit: (values) => {
            const newManager = {

                ...values,
                mobile: `${values.countryCode}${values.mobile}`,

            };
            console.log("new manager", newManager)
            dispatch(createManager(newManager)).then(() => {
                dispatch(getManager(''));
                toggle();
            });
        },
    });

    // Image
    const [selectedImage, setSelectedImage] = useState<any>();
    const handleImageChange = (event: any) => {
        const fileInput = event.target;
        if (fileInput.files && fileInput.files.length > 0) {
            const file = fileInput.files[0];
            const reader = new FileReader();
            reader.onload = (e: any) => {
                validation.setFieldValue('img', e.target.result);
                setSelectedImage(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // 
    const toggle = useCallback(() => {
        if (show) {
            setShow(false);
            setEventData("");
            setIsEdit(false);
            setSelectedImage('');
        } else {
            setShow(true);
            setEventData("");
            setSelectedImage('');
            validation.resetForm();
        }
    }, [show, validation]);

    // Search Data
    // const filterSearchData = (e: any) => {
    // const search = e.target.value;
    // const keysToSearch = ['username', 'email' ]; 
    // filterDataBySearch( search, keysToSearch)
    // };


    const columns = useMemo(() => [

        {
            header: "Manager Name",
            accessorFn: (row: any) => row.manager?.username ?? "N/A",
            enableColumnFilter: false,

        },
        {
            header: "Mobile",
            accessorFn: (row: any) => row.manager?.mobile ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Country",
            accessorFn: (row: any) => row.manager?.country ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Email",
            accessorFn: (row: any) => row.manager?.email ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Account",
            accessorFn: (row: any) => row.account?.[0]?.amount ?? "0",
            enableColumnFilter: false
        }

    ], []
    );



    return (
        <React.Fragment>
            <div className='container-fluid group-data-[content=boxed]:max-w-boxed mx-auto'>
                <BreadCrumb title='Manager Creation' pageTitle='Dashboards' />
                <ToastContainer closeButton={false} limit={1} />
                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
                    <div className="xl:col-span-12">
                        <div className="card" id="usersTable">
                            <div className="card-body">
                                <div className="flex items-center justify-end">
                                    <div className="shrink-0">
                                        <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block size-4" /> <span className="align-middle">Add Manager</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
                                <form action="#!">
                                    <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                                        {/* <div className="relative xl:col-span-2">
                                        <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for name, email, phone number etc..." autoComplete="off"
                                            onChange={(e) => filterSearchData(e)} />
                                        <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                                    </div> */}

                                        <div className="xl:col-span-3 xl:col-start-10">
                                            <div className="flex gap-2 xl:justify-end">
                                                <div>
                                                    <button type="button" className="bg-white border-dashed text-custom-500 btn border-custom-500 hover:text-custom-500 hover:bg-custom-50 hover:border-custom-600 focus:text-custom-600 focus:bg-custom-50 focus:border-custom-600 active:text-custom-600 active:bg-custom-50 active:border-custom-600 dark:bg-zink-700 dark:ring-custom-400/20 dark:hover:bg-custom-800/20 dark:focus:bg-custom-800/20 dark:active:bg-custom-800/20"><Download className="inline-block size-4" /> <span className="align-middle">Import</span></button>
                                                </div>
                                                <button className="flex items-center justify-center size-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"><SlidersHorizontal className="size-4" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-body">
                                {manager && manager.length > 0 ?
                                    <TableContainer
                                        isPagination={true}
                                        columns={(columns || [])}
                                        data={(manager || [])}
                                        customPageSize={7}
                                        divclassName="-mx-5 -mb-5 overflow-x-auto"
                                        tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                                        theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                                        thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                                        tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                                        PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                                    />
                                    :
                                    (<div className="noresult">
                                        <div className="py-6 text-center">
                                            <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                            <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                            <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ users We did not find any users for you search.</p>
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </div>


                {/* User Modal  */}
                <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
                    className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                    dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
                    <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                        <Modal.Title className="text-16">{"Add Manager"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                        <form action="#!" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>

                            <div className="mb-3">
                                <label htmlFor="username" className="inline-block mb-2 text-base font-medium">Manager Name</label>
                                <input type="text" id="username" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 capitalize" placeholder="Manager Name"
                                    name="username"
                                    onChange={validation.handleChange}
                                    value={validation.values.username || ""}
                                />
                                {validation.touched.username && validation.errors.username ? (
                                    <p className="text-red-400">{validation.errors.username}</p>
                                ) : null}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="mobile" className="inline-block mb-2 text-base font-medium">Mobile</label>

                                <div className="flex gap-5">
                                    <select
                                        name="countryCode"
                                        id="countryCode"
                                        className="form-select border-slate-200 dark:border-zink-500 dark:bg-zink-700 dark:text-zink-100 w-[35%]"
                                        onChange={validation.handleChange}
                                        value={validation.values.countryCode || "+971"}
                                    >
                                        <option value="+971">UAE (+971)</option>
                                        <option value="+966">Saudi (+966)</option>
                                        <option value="+974">Qatar (+974)</option>
                                        <option value="+91">India (+91)</option>
                                    </select>

                                    <input
                                        type="text"
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Enter mobile"
                                        className=" w-[65%] form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        onChange={validation.handleChange}
                                        value={validation.values.mobile || ""}
                                    />
                                </div>

                                {validation.touched.mobile && validation.errors.mobile ? (
                                    <p className="text-red-400">{validation.errors.mobile}</p>
                                ) : null}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="inline-block mb-2 text-base font-medium">Email</label>
                                <input type="email" id="email" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter Email"
                                    name="email"
                                    onChange={validation.handleChange}
                                    value={validation.values.email || ""}
                                />
                                {validation.touched.email && validation.errors.email ? (
                                    <p className="text-red-400">{validation.errors.email}</p>
                                ) : null}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="country" className="inline-block mb-2 text-base font-medium">Country</label>
                                <select
                                    id="country"
                                    name="country"
                                    className="form-select border-slate-200 dark:border-zink-500 dark:bg-zink-700 dark:text-zink-100"
                                    onChange={validation.handleChange}
                                    value={validation.values.country || ""}
                                >
                                    <option value="">Select Destination</option>
                                    <option value="dubai">Dubai</option>
                                    <option value="saudi">Saudi</option>
                                    <option value="jeddah">Jeddah</option>
                                    <option value="dammam">Dammam</option>
                                    <option value="riyadh">Riyadh</option>
                                    <option value="qatar">Qatar</option>
                                </select>
                                {validation.touched.country && validation.errors.country ? (
                                    <p className="text-red-400">{validation.errors.country}</p>
                                ) : null}
                            </div>

                            <div className="mb-3 relative">
                                <label htmlFor="password" className="inline-block mb-2 text-base font-medium">
                                    Password
                                </label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    placeholder="Must be 6 character or more"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10"
                                    onChange={validation.handleChange}
                                    value={validation.values.password || ""}
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute top-9 right-3 text-sm text-gray-500 dark:text-zink-200 focus:outline-none"
                                >
                                    {showPassword ?  <EyeOff /> : <Eye /> }
                                </button>
                                {validation.touched.password && validation.errors.password && (
                                    <p className="text-red-400 ">{validation.errors.password}</p>
                                )}
                            </div>


                            <div className="flex justify-end gap-2 mt-4">
                                <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={toggle}>Cancel</button>
                                <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                    {"Add Manager"}
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default ManagerCreations;
